import DataListBulkActionsContext from "@magicware/data-lists/DataListBulkActionsContext";
import { MenuAction } from "@magicware/data-lists/DataListContextMenu";
import { useTranslation } from "react-i18next";
import { useBaseAppId } from "../../navigation/baseApps";
import { useNewItemMenuAction } from "../../navigation/hooks";

export default function BaseAppVersionListMenuContext(props: { children?: React.ReactNode }) {
    const { t } = useTranslation();
    const actions: MenuAction[] = [];
    const baseAppId = useBaseAppId();
    const addAction = useNewItemMenuAction(t("add-version"), (n) => n.baseApps.detail.versions.new.url(baseAppId));
    return (
        <DataListBulkActionsContext defaultAction={addAction} actions={actions}>
            {props.children}
        </DataListBulkActionsContext>
    );
}
